import { createFeatureSelector, createSelector } from '@ngrx/store'
import { CountryState } from './country.state'

export const selectCountryState = createFeatureSelector<CountryState>('country')

export const selectAllCountries = createSelector(
  selectCountryState,
  (state: CountryState) => state.countries
)

export const selectSelectedCountry = createSelector(selectCountryState, state => state)
